/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  // getOrientation,
  // resetOrientation,
  // checkImage,
  fetchApi,
} from "../../../utils/methods";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import Waiting from "../../Waiting";
import { toast } from "react-toastify";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  // UploadPhotoContainerV1,
  // InputImageV1,
  ButtonContainer,
  EditorContainer,
  // RemoveImageV3,
  CustomCheckBoxButton
} from "../../CreateEvent/style";
import { Main } from "../../AdminTeamCreation/styles";
import {
// TitleContainer,
// CustomMenuItem,
// FieldTitle,
// ActivityDropdown,
} from "../../AdminTeamCreation/styles";
import Editor from '../../CKEditor';
import { ImageUrl, WellnessLevels } from "../../../utils/constants";
import { /*AdminEventsGoBackNewIcon,*/  closeIcon, RecognitionCloseIcon, UploadHDMIcon, RecognitionTickIcon, DropIcon,/* AdminLeftArrowIcon, AdminRightArrowIcon */} from "../../../utils/icons";
import { Border } from "../../Journeys/styles";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { eventsTierPoints, featuredMonths } from "../../../../mockData";
import { EditOndemandEventVideo } from "../../../redux/actions";
import {TitleContainer, NewActivityDropdownCommon} from '../../common/CommonDropDown/style';
import { Dropdown } from "react-bootstrap";
import { CreateOnDemandFitnessVideo, EditOnDemandVideo, /*FetchCoaches,*/ GetCategoryCoaches, OnSiteEventCategories } from '../../../redux/constants/apiConstants';
import { FormHeading } from "../../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import StepsHeading from "../../../components/RecogntionAdmin/corevalues/stepNames";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { CommonButtonBorder } from "../../common/commonStyles";
import { RadioButton, RadioButtonWrapper } from "../../RecogntionAdmin/styles";
import { ProfileThemesAll } from "../../../redux/constants/apiConstants";
import { http } from "../../../redux/http";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import Spinner from "../../common/Spinner";
// import { BASE_URL } from "../../../utils/config";
class CreateOndemandMain extends Component {
  constructor() {
    super();
    this.state = {
      title: "",
      url: "",
      time: "",
      description: "",
      imageName: "",
      imgSrc: "",
      classTypeKey: "",
      classCategoryTypeValue: [],
      onSiteCategoryValue: [],  
      selectedValues:[],
      pointValue: "",
      coachId: null,
      flayerName: "",
      buttonstatus: false,
      step: 1,
      so: false,
      showBack:false,
      buttonClickScrollTop:false,
      selectedOndemandCategory: '',
      selectedOnsiteCategory: '',
      selectedOndemandCategoryValue:[],
      so2: false,
      levels:null,
      getCoachData:[],
      so3: false,
      coachName: '',
      charCount:0,
      selectedOption: 0,
      onSiteCategories: [],
      getThemesValue:[],
      selectedTheme: null,
      themeId:null,
      featureMonth:null,
      featureId:null,
      previousTabId:null,
    };
  }

  componentDidMount() {
    const {
      history: {
        location: { pathname },
      },
      fetchOndemandEventDetailsById,
      ondemandEventDetail,
      fetchOndemandCategory,
      isEditCategory
    } = this.props;
    const selectedTabId = this.props.history.location?.state;
    this.setState({ previousTabId: selectedTabId });
    this.getThemes();
    const { flayerName } = this.state;
    fetchOndemandCategory();
    this.GetOnsiteCategories();
    if(!isEditCategory){
      this.fetchCoachData([]);
    }
    else{
      this.fetchCoachData(ondemandEventDetail?.hra_category_id);
    }
    if(isEditCategory){
      const StringArray = pathname.split("/");
      if (StringArray[StringArray.length - 1] != "") {
        fetchOndemandEventDetailsById(StringArray[StringArray.length - 1]);
      } else {
        fetchOndemandEventDetailsById(StringArray[StringArray.length - 2]);
      }
      if (!ondemandEventDetail || _.isEmpty(ondemandEventDetail)) {
        this.props.history.push(`/events`);
      } else {
        this.setState({
          title: ondemandEventDetail.title,
          imgSrc: `${ImageUrl}/${ondemandEventDetail.thumbnail_image}`,
          url: ondemandEventDetail.video_url,
          classTypeKey: ondemandEventDetail.category_name,
          time: ondemandEventDetail.time,
          point_value: ondemandEventDetail.point_value,
          description: ondemandEventDetail.description,
          coachId: ondemandEventDetail?.coach_id,
          flayerName: flayerName,
          imageName: ondemandEventDetail.thumbnail_image,
          classCategoryTypeValue: ondemandEventDetail.hra_category_id,
          imageValueForEdit:ondemandEventDetail.thumbnail_image,
          pointValue:ondemandEventDetail.point_value
        });
        if(ondemandEventDetail.question_id){
          // this.getWBAQuestions(ondemandEventDetail.hra_category_id, ondemandEventDetail.question_id)
        }
        if(ondemandEventDetail.levels){
          const selectedLevel = WellnessLevels.find((wellnessLevel) => wellnessLevel.level === ondemandEventDetail.levels);
          this.setState({levels:selectedLevel})
        }
      }}
  }

  componentDidUpdate() {
    if(this.state.buttonClickScrollTop){
      window.scrollTo(0,0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }
    const { ondemandEventDetail, isEditCategory } = this.props;
    const { getCoachData, coachName, classCategoryTypeValue } = this.state;
    if( isEditCategory && ondemandEventDetail?.coach_id && getCoachData.length>0 && !coachName && (ondemandEventDetail.hra_category_id==classCategoryTypeValue)){
      const coachData = getCoachData?.find((coach) => coach?.id == ondemandEventDetail?.coach_id);
      if(!coachName){
        this.setState({coachName:coachData?.name})
      }
    }
  }




  fetchCoachData = async(selectescategories)=>{
    let apiUrl = GetCategoryCoaches;
    const payload = {categories:[...selectescategories]};
    try{
      const res = await fetchApi(apiUrl, "POST", payload);
      if(res.message && res.code !== -273){
        toast.error(res.message);
      }else{
        const coachList = [
          {
            id: null,
            name: "None",
            profile_image:"",
            about: "",
            education: ""
          },
          ...(res.data || [])
        ]
        this.setState({
          getCoachData:coachList
        })
      }
    }catch(error){
      toast.error(error)
    }
  }


  getThemes = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${ProfileThemesAll}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        let data = [{ month_number: 0, theme_text: 'None', month:"" }];
        this.setState({
          // getThemesValue: (res.all_themes)
          getThemesValue: data.concat(res.all_themes)
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  GetOnsiteCategories = async()=>{
    let category_type = "theme"
    let apiUrl = OnSiteEventCategories + "/"  + category_type;
    try{
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === "success"){
        this.setState({
          onSiteCategories:res.data
        })
      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }

  // onSelectThemeType = (selectedItem) => {

  //   this.setState({
  //     selectedTheme: selectedItem,
  //     themeId: selectedItem.id,
  //   });
  // };

  onSelectThemeType = (selectedItem) => {
    this.setState({
      selectedTheme: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      themeId: selectedItem.month_number,
    });
  };


  onSelectFeatureMonth = (selectedItem) => {
    window.console.log("featureMonth", selectedItem);
    this.setState({
      featureMonth: selectedItem.name,
      featureId: selectedItem.id,
    });
  };

  onChangeInput = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onChangeURL = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        url: e.target.value,
      });
    }
  };

  onChangeTime = (e) => {
    const numValidate = /^[0-9\b]+$/;
    if (e.target.value === "" || numValidate.test(e.target.value)) {
      this.setState({ time: e.target.value });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }


  // onChange = (e) => {
  //   let file = e.target.files[0];
  //   let fileArr = e.target.files;
  //   if (e.target.files[0]) {
  //     if (checkImage(fileArr)) {
  //       if (file?.size / 1000000 <= 20) {
  //         let reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         const array = document
  //           .getElementById("event-upload-file")
  //           .value.split("\\");
  //         reader.onloadend = () => {
  //           this.setState({
  //             imgSrc: reader.result,
  //             imageName: array[array.length - 1],
  //           });
  //           getOrientation(file, (or) => {
  //             resetOrientation([reader.result], or, (baseImage) => {
  //               this.setState({
  //                 imgSrc: baseImage,
  //               });
  //             });
  //           });
  //         };
  //       } else {
  //         toast.error("Please select image file less than 20MB");
  //         document.getElementById("event-upload-file").value = "";
  //       }
  //     } else {
  //       toast.error("Please select correct file format");
  //       document.getElementById("event-upload-file").value = "";
  //     }
  //   }
  // };

  // onSelectClass = (name, value, key) => {
  //   const {classCategoryTypeValue} = this.state;


  //   if(classCategoryTypeValue.includes(value)){
  //     let index = classCategoryTypeValue.findIndex((item) => item === value);
  //     if(index>-1){
  //       classCategoryTypeValue.splice(index, 1);
  //     }
  //   }
  //   else{
  //     if(classCategoryTypeValue.length <= 4)
  //     {
  //       classCategoryTypeValue.push(value);
  //     }
  //   }

  //   this.setState({
  //     [name]: value.toString(),
  //     selectedOndemandCategoryValue:[value],
  //     classTypeKey: key,
  //     coachId: null,
  //     coachName: '',
  //   }, () => {
  //     this.fetchCoachData(value);
  //   })
  // };


  onSelectClass = (name, value, key) => {
    const selectedValues = [...this.state[name]];
  
    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 5) {
        selectedValues.push(value);
      }
    }
  
    this.setState({
      [name]: selectedValues,
      classTypeKey: key,
      coachId: null,
      coachName: '',
    }, () => {
      if (name === "classCategoryTypeValue") {
        this.fetchCoachData(this.state.classCategoryTypeValue);
      }
    });
  };
  

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };


  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };

  saveOndemandEvent = () => {
    // e.preventDefault();
    const {
      title,
      url,
      // classCategoryTypeValue,
      time,
      description,
      themeId,
      imgSrc,
      coachId,
      selectedOption,
      classCategoryTypeValue,
      onSiteCategoryValue,
      pointValue,
      featureId
    } = this.state;
    // const { createOndemand } = this.props;
    this.setState({
      buttonstatus: true,
    });

    // const OndemandEventDetails = {
    //   title: title,
    //   image: imgSrc,
    //   video_url: url,
    //   hra_category_id: classCategoryTypeValue,
    //   time: time,
    //   point_value: pointValue,
    //   description: description,
    //   coach_id: coachId,
    //   flyer: flayerName,
    // };
    const OndemandEventDetails = {
      title: title,
      image: imgSrc,
      description: description,
      // type_of_events: selectedOption === 0 ? "on-demand" : "onsite",
      type_of_events: selectedOption === 0 ? "on-demand" : "theme",
      video_url: url,
      time: time,
      onsite_event_category_id:selectedOption === 1 ? onSiteCategoryValue :[],
      hra_category_id: selectedOption === 0 ? classCategoryTypeValue : [],
      theme_id: themeId === 0 || !themeId  ? null : themeId,
      coach_id:coachId,
      point_value: pointValue,
      featured_month: selectedOption === 1 ? featureId : null,
    };

    // createOndemand(OndemandEventDetails);
    this.PostOndemandEvent(OndemandEventDetails);
  };


  PostOndemandEvent = async(payload)=>{
    try{
      const res = await fetchApi(CreateOnDemandFitnessVideo, "POST",payload);

      if(res?.status === "success"){
        toast.success(res.data[0]);
        window.console.log("Previous Tab ID:", this.state.previousTabId);
        if (this.state.previousTabId === 1) {
          this.props.history.push({pathname:"/company/events",state:"updateData"});
        } else if (this.state.previousTabId === 2) {
          this.props.history.push({pathname:"/company/events/completed",state:"updateData"});
        } else if (this.state.previousTabId === 3) {
          this.props.history.push({pathname:"/company/events/library",state:"updateData"});
        } else {
          this.props.history.push("/company/events"); 
        }
        // this.props.history.push({pathname:"/company/events",state:"updateData"})
        this.setState({
          buttonStatus: false,
        });
      }else{
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      }
    }catch(error){
      toast.error(error);
      this.setState({
        buttonStatus: false,
      });
    }finally{
      this.setState({
        buttonstatus: false,
      });
    }
  }

 

  editOndemandEvent = () => {
    // e.preventDefault();
    const {
      title,
      url,
      classCategoryTypeValue,
      time,
      description,
      pointValue,
      imgSrc,
      coachId,
      flayerName,
      classTypeKey,
      imageValueForEdit,
      question,
      levels
    } = this.state;
    const { ondemandEventDetail } = this.props;
    this.setState({
      buttonstatus: true,
    });
    const OndemandEventDetails = {
      id: ondemandEventDetail.id,
      title: title,
      image: imgSrc,
      video_url: url,
      hra_category_id: classCategoryTypeValue,
      time: time,
      point_value: pointValue,
      description: description,
      coach_id: coachId,
      flyer: flayerName,
      imageUpdated:imageValueForEdit===ondemandEventDetail.thumbnail_image?0:1
    };
    OndemandEventDetails['question_id'] = question && question.id ? question.id : null;
    OndemandEventDetails['levels'] = levels?.level;
    // EditOndemandEventVideo(OndemandEventDetails, classTypeKey);
    this.editOndemandEventVideo(OndemandEventDetails, classTypeKey);
  };

  editOndemandEventVideo = async(payload, category)=>{
    try{
      const res = await fetchApi(EditOnDemandVideo, "PUT",payload);
      if(res.message){
        toast.error(res.message);
        this.setState({
          buttonstatus: false,
        });
      }else{
        toast.success(res.data[0]);
        this.props.history.push({pathname:`/events/on-demand/${category}/${payload.id}`});
        this.setState({
          buttonstatus: false,
        });
      }
    }catch(error){
      toast.error(error);
      this.setState({
        buttonstatus: false,
      });
    }
  }

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
 
    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); // Strip HTML tags for char count
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop:true });
  };

  close = () =>(
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{maskType: "alpha",}}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  redirect=()=>{
    // this.props.history.push(`/events`);
    this.props.history.goBack();
  }
  
  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect }>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.isEditCategory?this.props.t("Edit On-Demand Event"):this.props.t("Create Engagement Event ")}
    </FormHeading>
  );

  stepOneForm = () => {
    const {
      // title,
      // url,
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="ondemand"/>
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName" style={{color:"#005c87"}}>{this.props.t("Event Introduction")}</div>
              </div> */}
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the Event")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter title")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/30 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Event image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
              
                {/* <UploadPhotoContainerV1>
                  <div className="innerDivImageContainer">
                    {this.state.imgSrc ? (
                      <RemoveImageV3>
                        <img alt="profilre-img" src={this.state.imgSrc}></img>
                        <div className="main-div" onClick={this.removePhoto}>
                          <div className="icon-div" ><div className="sub-icon-div">{closeIcon("#F37A65","8","8")}</div></div>
                        </div>
                      </RemoveImageV3>
                    ) : (
                      <div className="uploadImage">

                        <InputImageV1
                          className="edit-profile-pic "
                          imageReload={1} 
                          style={{background:"unset",color:"#005c87"}}
                        >
                          <div className="middle-section">
                            <div>{UploadHDMIcon(20,25)}</div>
                            <div className="title">{this.props.t("Upload File")}</div>
                            <div className="sub-title">({this.props.t(".jpeg, .png")})</div>
                            
                          </div>
                       
                          <input
                            id="event-upload-file"
                            type="file"
                            name="user"
                            accept="image/jpeg, image/jpg, image/png"
                            multiple={false}
                            onChange={(e) => this.onChange(e)}
                            onClick={(e) =>
                              e.target.files[0] && this.onChange(e)
                            }
                          />
                        </InputImageV1>
                      </div>
                    )}

                  
                  </div>
                </UploadPhotoContainerV1> */}
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <InputContainer  isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About The Event")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      pointValue: name.value,
    });
  };

  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  stepTwoForm = () => {
    const {
      time,
      classCategoryTypeValue,
      pointValue,
      step,
      url,
      getCoachData,
      coachId,
      coachName,
      selectedOption,
      onSiteCategories,
      onSiteCategoryValue,
      getThemesValue,
      selectedTheme,
      featureMonth
    } = this.state;

    const { ondemandCategory, isEditCategory } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="ondemand" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName" style={{ color: "#005c87" }}>
                  {this.props.t("How would you like to customize your event, and when do you plan to launch it?")}
                </div>
              </div> */}
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("Type of event")}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"On demand"}</div>              
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Theme"}</div>              
                    </div>
                  </RadioButtonWrapper>
                </div>
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />

                {selectedOption === 0 ?  <>
                  <InputContainer isFlex={"0 0 220px"}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb="12px">
                      {this.props.t("Select category")}
                      {<div className="subDescription">(min 1 & max 5)</div>}
                      {<span>*</span>}
                    </StyledLabel>
                    <div className="radioButtonClassCategoriesV1" >
                      {
                        ondemandCategory.map((category, index)=>(
                          <div className="labelName" key={category.id}>
                            <CustomCheckBoxButton
                              isSelected={classCategoryTypeValue.includes(ondemandCategory[index].id)}
                              onClick={() => {
                                this.onSelectClass(
                                  "classCategoryTypeValue",
                                  ondemandCategory[index].id,
                                  ondemandCategory[index].name
                                );
                                this.setState({
                                  selectedOndemandCategory: ondemandCategory[index].name
                                });
                              }}
                              background={"#85c0ea"}
                            >
                              {classCategoryTypeValue.includes(ondemandCategory[index].id) &&  <div>{RecognitionTickIcon()}</div>}
                              {/* { this.state.classCategoryTypeValue?.includes(ondemandCategory[index].id) && <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>} */}
                            </CustomCheckBoxButton>
                            {category.name}
                          </div>
                        ))
                      }
                    </div>
                  </InputContainer>
  
                  <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  <InputContainer>
  
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("URL")}{<span>*</span>}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter meeting URL")}
                      name="title"
                      onChange={this.onChangeURL}
                      value={url}
                      maxLength="100"
                      style={{background:"white"}}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                  </InputContainer>
                  <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
  
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                      {this.props.t("Total event duration (in minutes)")}{<span>*</span>}
                    </StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter event duration")}
                      name="title"
                      onChange={this.onChangeTime}
                      value={time}
                      maxLength="3"
                      style={{background:"white"}}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                  </InputContainer>
                  <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />


                  {<TitleContainer tileContainerStyle={{padding:"0px 0px 8px 0px" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"0px"}>{this.props.t("Event Host")}</StyledLabel>
                    <NewActivityDropdownCommon
                      onClick={() => this.setState({ so3: !this.state.so3 })}
                    >
                      <Dropdown.Toggle>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{color: !coachName&& "#BDBDBD" }}>{ coachId === 0 ?"None":coachName?coachName:"Select event host"}</div>
                          <div>
                            {getCoachData?.length>0&& <div style={{position:"absolute",right:"16px",top:"18px",cursor:"pointer"}}> {DropIcon("#F37A65")}</div>}
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      {getCoachData?.length>0&&<Dropdown.Menu>
                        {getCoachData?.length>0 && getCoachData.map((item, index) => (
                          <Dropdown.Item
                            eventKey={index}
                            key={index}
                            onClick={() =>
                              this.onDropDownSelectCoach("coachId", item.id, item.name)
                            }
                            active={coachId !== null && coachId === item.id} 
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>}
                    </NewActivityDropdownCommon>
                  </TitleContainer>}

                  <Border style={{ background: '#EFEFEF', margin: '8px 0px',display:"flex" }} />
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Monthly Theme")}
                    isRequired={true}
                    dropdownOpen={this.state.so}
                    placeholder={this.props.t("Select monthly theme")}
                    title={
                      selectedTheme
                    }
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={getThemesValue}
                    onSelect={this.onSelectThemeType}
                    active={selectedTheme}
                    itemValue={true}
                    valueIndex={0}
                    onSelectParameter={["theme_text", "month_number", "month"]}
                    // onSelectParameter={["month", "id", "theme_icon"]}
                    dropIcon={true}
                    labelMargin={"0px"}
                    fontSize={"14px"}
                    showWrapText={1}
                  />

                  {/* <Border style={{ background: '#EFEFEF', margin: '0px 0px 8px 0px',display:"flex" }} />
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Event point value")}
                    isRequired={true}
                    dropdownOpen={this.state.so}
                    placeholder={this.props.t("Select point value")}
                    title={
                      pointValue
                        && `${pointValue} Points`
                    }
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={eventsTierPoints}
                    onSelect={this.onSelectPoints}
                    active={pointValue}
                    onSelectParameter={["pointValue", "value", "key"]}
                    valueString={"Points"}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    dropIcon={true}
                    fontSize={"14px"}
                  /> */}
                                    

                </>:null}




                {selectedOption === 1 ? <><InputContainer isFlex={"0 0 290px"}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb="12px">
                    {this.props.t("Select category")}
                    {<div className="subDescription">(min 1 & max 5)</div>}
                    {<span>*</span>}
                  </StyledLabel>
                  <div className="radioButtonClassCategoriesV1" >
                    {
                      onSiteCategories?.map((category, index)=>(
                        <div className="labelName" key={category.id}>
                          <CustomCheckBoxButton
                            isSelected={onSiteCategoryValue.includes(onSiteCategories[index].id)}
                            onClick={() => {
                              this.onSelectClass(
                                "onSiteCategoryValue",
                                onSiteCategories[index].id,
                                onSiteCategories[index].category_name
                              );
                              this.setState({
                                selectedOnsiteCategory: onSiteCategories[index].category_name
                              });
                            }}
                            background={"#85c0ea"}
                          >
                            {onSiteCategoryValue.includes(onSiteCategories[index].id) &&  <div>{RecognitionTickIcon()}</div>}
                            {/* { this.state.classCategoryTypeValue?.includes(ondemandCategory[index].id) && <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>} */}
                          </CustomCheckBoxButton>
                          {category.category_name}
                        </div>
                      ))
                    }
                  </div>
                </InputContainer>
                </> : null}

                <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px', display:"flex"}}/>

                {selectedOption === 1 ? <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"8px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Feature Month")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Month")}
                  title={
                    featureMonth
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={featuredMonths}
                  onSelect={this.onSelectFeatureMonth}
                  active={featureMonth}
                  itemValue={true}
                  valueIndex={0}
                  onSelectParameter={["name","id"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  showWrapText={0}
                /> : null}








                {selectedOption === 0 ?<CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Event point value")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select point value")}
                  title={
                    pointValue
                      && `${pointValue} Points`
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={eventsTierPoints}
                  onSelect={this.onSelectPoints}
                  active={pointValue}
                  onSelectParameter={["pointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"4px"}
                  dropIcon={true}
                  fontSize={"14px"}
                />:null}
               

                {isEditCategory&&<TitleContainer tileContainerStyle={{padding:"20px 0px 20px 0px" }}>
                  <StyledLabel margin={"0px"}>{this.props.t("Level")}</StyledLabel>
                  <NewActivityDropdownCommon
                    onClick={() => this.setState({ so2: !this.state.so2 })}
                    onSelect={(index) =>
                      this.onDropDownSelect("levels", WellnessLevels[index])
                    }
                  >
                    <Dropdown.Toggle>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{color: !this.state["levels"]?.level && "rgba(0, 92, 135, 0.30)" }}>{this.state["levels"] && this.state["levels"].level && this.state["levels"].level || "Select Level"}</div>
                        <div>
                          <img
                            alt="image"
                            src={"/public/images/teamDownArrow.svg"}
                          />
                        </div>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {WellnessLevels.map((item, index) => (
                        <Dropdown.Item
                          eventKey={index}
                          key={index}
                          onSelect={() =>
                            this.onDropDownSelect("levels", item)
                          }
                          active={this.state["levels"] && this.state["levels"].id && this.state["levels"].id === item.id}
                        >
                          {item["level"]}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </NewActivityDropdownCommon>
                </TitleContainer>}


                {isEditCategory&&<Border style={{background:'#EFEFEF',margin:'30px 0px 0px 0px', display:"flex"}}/>}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      title,
      url,
      time,
      description,
      imgSrc,
      buttonstatus,
      step,
      charCount,
      themeId,
      selectedOption,
      classCategoryTypeValue,
      onSiteCategoryValue,
      featureId
    } = this.state;

    const isDisabled = selectedOption === 0
      ? classCategoryTypeValue.length === 0 || themeId === null || !time || !url || buttonstatus
      : onSiteCategoryValue.length === 0 || buttonstatus || featureId === null;


    const { ondemandCategory, isEditCategory } = this.props;
    if (isUndefined(ondemandCategory) || isNull(ondemandCategory)) {
      return <Waiting />;
    }
    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : this.stepTwoForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description || (charCount > 3000)} onClick={!title||!imgSrc|| !description || (charCount > 3000) ? null: () => this.updateStep(2)}>
               Next
                {/* {!title||!imgSrc|| !description || (charCount > 3000) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <div className="wrapper">

              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                 Back
              </CommonButtonBorder>

              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                disabled={isDisabled}
                onClick={!buttonstatus ? isEditCategory ? () => this.editOndemandEvent() :  () => this.saveOndemandEvent() : null}>
                {buttonstatus ? <Spinner color={"#F37A65"}/> : ' Create '}
                {buttonstatus ? null  : RecognitionTickIcon(isDisabled ? "#989898" : "white", 15,10)}
              </CommonButtonPopup>

              {/* <Button
                color="#F37A65"
                onClick={!buttonstatus ? isEditCategory? () => this.editOndemandEvent() :  () => this.saveOndemandEvent() : null}
                marginAuto="1"
                disabled={
                  (themeId === null) || 
                  !time || selectedValues.length==0 ||
                  !url ||
                  buttonstatus
                }
                isOnDemandEvent={true}
              >
                <span style={{display: "flex", flexDirection: "row", gap: "12px", alignItems: "center"}}>
                  <span>{this.props.t("Create")}</span>
                </span>
              </Button> */}
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

CreateOndemandMain.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
  location: PropTypes.shape({
    state: PropTypes.any,
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string
  }),
};

const mapStateToProps = (state) => ({
  ondemandEventDetail: state.events.ondemandEventDetail,
  ondemandCategory: state.events.ondemandCategory,
});

const mapDispatchToProps = (dispatch) => ({
  EditOndemandEventVideo: (data, category) =>dispatch(EditOndemandEventVideo(data, category)),
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(CreateOndemandMain));